import script from "./SetupAssistantStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupAssistantStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import GlowFrame from "@/components/catering/GlowFrame.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import SwooshArrow from "@/components/catering/SwooshArrow.vue";
script.components = Object.assign({}, { GlowFrame, NeueButton, SwooshArrow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { GlowFrame, NeueButton, SwooshArrow }, script.__o.components);}